import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="coming-soon-page min-h-screen flex flex-col text-editorial-primary">
      <header className="shrink-0 pt-10 md:pt-14 px-6 text-center">
        <p className="text-xs md:text-sm font-medium tracking-[0.4em] uppercase text-editorial-primary">
          Edutopia
        </p>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-6 py-16 md:py-24">
        <div className="w-full max-w-2xl rounded-3xl border border-editorial-stroke bg-canvas/95 px-8 py-12 md:px-12 md:py-16 shadow-sm">
          <p
            className="text-center text-sm font-medium tracking-[0.35em] uppercase text-editorial-primary/80"
            aria-hidden="true"
          >
            404
          </p>
          <h1 className="mt-4 text-center text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-editorial-accent">
            Page not found.
          </h1>
          <p className="mt-6 text-center text-base md:text-lg font-normal max-w-xl mx-auto text-editorial-primary/90 leading-relaxed">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <div className="mt-10 flex justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-2xl border-2 border-editorial-primary bg-transparent px-8 py-3 text-xs font-medium uppercase tracking-[0.2em] text-editorial-primary transition hover:bg-editorial-primary/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-editorial-primary"
            >
              Back home&nbsp;
              <span aria-hidden="true" className="ml-1">
                →
              </span>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
